import { ReservationUnavailableModelBase } from "./ReservationUnavailableModel.base"


/* A graphql query fragment builders for ReservationUnavailableModel */
export { selectFromReservationUnavailable, reservationUnavailableModelPrimitives, ReservationUnavailableModelSelector } from "./ReservationUnavailableModel.base"

/**
 * ReservationUnavailableModel
 */
export const ReservationUnavailableModel = ReservationUnavailableModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self))
    }
  }))
